var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('nav',{staticClass:"Menu",class:_vm.classList},_vm._l((_vm.items),function(item){return _c('Link',{key:item.to.name,staticClass:"Menu__link",attrs:{"to":item.to,"arrow":_vm.arrow,"label":item.label,"alternate":item.alternate}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }